import React from "react";
import { links } from "../../config/links";

const perguntas = [
  {
    q: "O que eu encontro para comprar?",
    a: "A plataforma tem oito segmentos: sementes, fertilizantes, adjuvantes e biológicos, combustíveis, peças e implementos, agropecuárias, revendas multiproduto e corretoras de grãos. O catálogo é de cada empresa cadastrada, então o que aparece varia conforme quem atende a sua região.",
  },
  {
    q: "Preciso pedir cotação para saber o preço?",
    a: "Não. O preço de cada embalagem já aparece no produto, com o mínimo de compra e a modalidade de frete. Cotação existe só para o caso de você precisar de algo que nenhum parceiro publicou no catálogo ainda.",
  },
  {
    q: "Quem entrega, o parceiro ou eu busco?",
    a: "Depende da modalidade da proposta. Em CIF o parceiro entrega no endereço da fazenda que você cadastrou. Em FOB você retira na loja. Cada proposta mostra qual é a modalidade antes de você fechar.",
  },
  {
    q: "Como sei em que pé está o meu pedido?",
    a: "O pedido tem status próprio: aprovado, itens em separação, a caminho e entregue. Cada mudança gera uma notificação, e o histórico fica no detalhe do pedido.",
  },
  {
    q: "Chegou produto errado ou danificado. E agora?",
    a: "Você abre a solicitação de devolução no próprio pedido, escolhe o motivo e anexa foto. O parceiro responde pelo painel e você acompanha até a conclusão.",
  },
  {
    q: "Quero vender no app. Como começo?",
    a: "Pelo cadastro de empresa. Você informa dados da empresa, endereço, dados fiscais, conta ou chave PIX para repasse e aceita o contrato de adesão. Depois da aprovação, o acesso ao painel chega por e-mail.",
  },
  {
    q: "O que acontece com os meus dados?",
    a: "Tratamos os dados conforme a LGPD, e a política de privacidade descreve o que é coletado e por quê. A exclusão da conta pode ser pedida pelo próprio app, sem passar pelo suporte.",
  },
];

const Perguntas: React.FC = () => (
  <section id="perguntas" className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <p className="eyebrow">Dúvidas</p>
          <h2 className="mt-4 font-display text-display-md font-bold text-soil">
            Perguntas que sempre chegam
          </h2>
          <p className="mt-5 text-base leading-relaxed text-soil/70">
            Não achou o que precisava? Fale com a gente no WhatsApp{" "}
            <a
              href={links.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-agro-primary underline decoration-agro-accent decoration-2 underline-offset-2"
            >
              {links.phoneDisplay}
            </a>
            .
          </p>
        </div>

        <div className="divide-y divide-bone-300 border-y border-bone-300">
          {perguntas.map((p) => (
            <details key={p.q} className="group">
              <summary className="flex cursor-pointer items-start justify-between gap-6 py-5 font-display text-lg font-bold text-soil marker:content-none [&::-webkit-details-marker]:hidden">
                {p.q}
                <span className="mt-1 shrink-0 text-soy-dark transition-transform duration-200 group-open:rotate-45">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
                    <path d="M8 3v10M3 8h10" />
                  </svg>
                </span>
              </summary>
              <p className="max-w-2xl pb-6 text-base leading-relaxed text-soil/70">
                {p.a}
              </p>
            </details>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Perguntas;
